import React, {useContext} from "react";
import CustomerAddresses from "./CustomerAddresses";
import CustomerAccounts from "./CustomerAccounts";
import { CustomerMemos } from './CustomerMemos';

export default function CustomerInfo(){
    return (
        <>
            <CustomerAddresses />
            <CustomerAccounts />
            <CustomerMemos />
        </>
    )
}